var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-block-wrapper"},[(_vm.$slots.title)?_c('div',{staticClass:"v-block-wrapper__title"},[_vm._t("title")],2):_vm._e(),_c('div',{class:_setup.classes},[(_vm.title)?_c('div',{staticClass:"v-block-wrapper__inside-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }